import React from 'react';
import PropTypes from 'prop-types';

import Check from '../../../common/components/icons/Check';

import './Feature.scss';

const Feature = ({ title, content } = props) => {
  return (
    <div>
      <Check className="feature__icon" />
      <strong className="feature__title">{title}</strong>
      <p className="feature__content">{content}</p>
    </div>
  );
};

Feature.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};

export default Feature;
